export enum ProductNutritionElementSign {
  LESS = 'LESS',
  MORE = 'MORE',
  EQUAL = 'EQUAL'
}
